var gosling = {
  product: function(){
    
    // varinat
    function required(){
      var required = true;
      
      $('.guest__1 .gtfn_input').each(function(){
        if($(this).find('.required_input') == ''){
           required = false;
        }        
      });
      
      $('.guest__2 .gtfn_input').each(function(){
        if($(this).find('.required_input') == ''){
           required = false;
        }  
      });
      if(required){
      }else{
      }
    }
    
    
    $('.guest_addtocart_poup').on('click', function(){
      $('.guest__popup').show();
      $('sticky-header').hide();
      $('body').addClass('active');

      var txt = $('select.select__select').val();
      console.log(txt);
      if(txt.indexOf('Local') != -1){
        $('.hide_variant').hide();
        $('.hide_inter').show();
      }else{
        $('.hide_variant').show();
        $('.hide_inter').hide();
      }
      
    });
    
    
    $('.g_options').on('change', function(){
      var select_option = [];
      
      $('.g_product_variants .g_option_variants').each(function(){
         var val = $(this).find('.g_options').val();
        select_option.push(val);
      });
       
      
      var id = 0;
      $.each(g_variant, function(index, item){
        if(arrayEquals(item.options, select_option)){
         $('.g_product').attr('data-id', item.id);
          return;
        }
        
      });
      
      function arrayEquals(a, b) {
          return Array.isArray(a) &&
              Array.isArray(b) &&
              a.length === b.length &&
              a.every((val, index) => val === b[index]);
      }
        
    });
    
    $('.guest_addtocart').on('click', function(){
      var id = $('.g_product').attr('data-id');
     // add_to_cart(id, 1);
      setTimeout(function(){
        window.location.href = "/cart";
      }, 1400);
    });
    
    
    function add_to_cart(id, qty){
      var name = $('#properties_Name').val();
      var Email = $('#properties_Email').val();
      var City = $('#properties_City').val();
      var State = $('#properties_State').val();
      var Zip = $('#properties_Zip').val();
      var DOB = $('#properties_DOB').val();
      
      var Check_In = $('#properties_Check_In_Date').val();
      var Check_Out = $('#properties_Check_Out_Date').val();
      var Airline = $('#properties_Airline_Flight_Number').val();
      var Participating = $('#properties_Participating').val();
      var GHIN = $('#properties_GHIN_Number').val();
      
      setTimeout(function(){
        $.ajax({
            type: 'POST',
            dataType: 'json', 
            url: '/cart/add.js',
            data: {
              quantity: qty,
              id: id,
              properties:{
                Name: name,
                Email: Email,
                City: City,
                State: State,
                Zip: Zip,
                DOB: DOB,
                Check_In: Check_In,
                Check_Out: Check_Out,
                Airline: Airline,
                Participating: Participating,
                GHIN: GHIN
              }
            }, 
             success: function (data) {  
              	window.location.href = "/cart";
             } 
        });
      }, 400);
    }
    
  },
  international: function(){
    
    $('.intnt_link').on('click', function(e){
        e.preventDefault();
         var x = $('.newsletter_section').offset().top;
         console.log(x);
        $('html, body').animate({ scrollTop: x }, 400);
    });
    
  },
  home: function(){
      $('.faq_question').on('click', function(){
          $(this).toggleClass('active');
          $(this).next('.faq_answer').slideToggle();
      });
  },
  registration: function(){

    var code = [];
    code.push("code_1");  code.push("code_2");  code.push("code_3");
    
     
    $('.Invitation_code').on('change paste keyup', function(){
        var value = $(this).val();
        if($.inArray(value, code) != -1) {
               $('.Invitation_code').removeClass('error');
               $('.reg_btn').removeAttr('disabled');
          } else {
               $('.Invitation_code').addClass('error');
               $('.reg_btn').attr('disabled', 'disabled'); 
          } 
    });
    
  },
  password: function(){
      $('.lgf_btn').on('click', function(){
          var password = $('.lgf_input_style').val();
          if(password == 'rum'){
              $('.login_form, .rgtn_section').slideToggle(); 
              gosling.setCookie('pass', 1, 1);
          }else{
             alert('Password Wrong');
              $('.lgf_input_style').val('');
           }
      });

     if(gosling.getCookie('pass') == 1){
         $('.login_form').hide();
         $('.rgtn_section').show(); 
     }
  },
  setCookie: function(key, value, expiry) {
        var expires = new Date();
        expires.setTime(expires.getTime() + (expiry * 24 * 60 * 60 * 1000));
        document.cookie = key + '=' + value + ';expires=' + expires.toUTCString();
    },
    getCookie: function(key) {
        var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
        return keyValue ? keyValue[2] : null;
    },
    eraseCookie: function(key) {
        var keyValue = getCookie(key);
        setCookie(key, keyValue, '-1');
    }
}

$(function(){
  gosling.product();
  gosling.international();
  gosling.home();

  // gosling.registration();

  gosling.password();
});

